<template>
  <div>
    <b-container fluid class="content">
      <b-row class="mt-4">
        <b-col>
          <b-card no-body>
            <b-card-body>
              <b-row class="align-items-center border-bottom pb-3 mb-3">
                <b-col>
                  <h4 class="mb-0">H5 Tables</h4>
                  <div class="text-muted">Store: {{ LocationID }}</div>
                </b-col>
                <b-col class="text-right">
                  <el-button size="small" @click="go_back">{{ $t("Back") }}</el-button>
                  <el-button
                    size="small"
                    type="primary"
                    icon="el-icon-document"
                    :disabled="allRows.length == 0"
                    @click="download_pdf"
                  >
                    Download PDF
                  </el-button>
                  <el-button
                    size="small"
                    type="primary"
                    icon="el-icon-download"
                    :disabled="allRows.length == 0"
                    @click="download_zip"
                  >
                    Download QR Zip
                  </el-button>
                  <el-button
                    size="small"
                    type="success"
                    :loading="sendingStoreInfo"
                    @click="send_h5_store_info"
                  >
                    Send Info to H5 Store
                  </el-button>
                </b-col>
              </b-row>

              <b-alert
                :show="messageCountdown"
                dismissible
                variant="success"
                @dismissed="messageCountdown = 0"
              >
                {{ text_message }}
              </b-alert>

              <b-alert
                :show="showTableChangedWarning"
                variant="warning"
              >
                Table information has changed since the last update. Click "Send Info to H5 Store" to update the API server.
              </b-alert>

              <b-table
                responsive
                striped
                hover
                :items="allRows"
                :fields="fields"
                show-empty
                empty-text="No H5 tables"
              >
                <template #cell(TName)="data">
                  <strong>{{ data.item.TName }}</strong>
                </template>
                <template #cell(QRCodeUrl)="data">
                  <a :href="data.item.QRCodeUrl" target="_blank">{{ data.item.QRCodeUrl }}</a>
                </template>
                <template #cell(QRCode)="data">
                  <img
                    v-if="qrImages[data.item.key]"
                    class="qr-image"
                    :src="qrImages[data.item.key]"
                    :alt="data.item.TName + ' QRCode'"
                  />
                  <span v-else class="text-muted">Loading...</span>
                </template>
              </b-table>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
    <div class="loading-overlay" v-if="show_loading">
      <div class="spinner"></div>
      <p>Loading...</p>
    </div>
  </div>
</template>

<script>
import { Button } from "element-ui";
import { getStore } from "../../util/helper";
import { zipSync } from "fflate";
import { jsPDF } from "jspdf";

const axios = require("axios");
const PDF_ITEMS_PER_PAGE = 20;

export default {
  components: {
    [Button.name]: Button,
  },
  data() {
    return {
      show_loading: false,
      sendingStoreInfo: false,
      token: "",
      user_id: 0,
      LocationID: "",
      locationName: "",
      storeName: "",
      OnlineSourceIDn: 0,
      SourceType: "",
      pickup_url: "",
      pickup_qrcode: null,
      table_list: [],
      qrImages: {},
      qrExtensions: {},
      text_message: "",
      messageCountdown: 0,
      showTableChangedWarning: false,
      fields: [
        { key: "TName", label: "Table Name" },
        { key: "QRCodeUrl", label: "QRCode URL" },
        { key: "QRCode", label: "QRCode Image" },
      ],
    };
  },
  computed: {
    allRows() {
      let rows = [];
      if (this.pickup_url) {
        rows.push({
          key: "pickup",
          TName: "Pickup",
          QRCodeUrl: this.pickup_url,
          QRCodeImage: this.pickup_qrcode ? this.pickup_qrcode.data_url : "",
          QRCodeExtension: this.pickup_qrcode ? this.pickup_qrcode.extension : "",
        });
      }
      for (let i = 0; i < this.table_list.length; i++) {
        let row = this.table_list[i];
        rows.push({
          key: "table-" + row.PKTableIDn,
          TName: row.TName,
          QRCodeUrl: row.QRCodeUrl,
          QRCodeImage: row.QRCodeImage || "",
          QRCodeExtension: row.QRCodeExtension || "",
          Status: row.Status,
        });
      }
      return rows;
    },
  },
  methods: {
    go_back() {
      this.$router.push({ path: "/onlinestore", query: { LocationID: this.LocationID } });
    },
    check_table_changed_warning() {
      this.showTableChangedWarning = false;
      for (let i = 0; i < this.table_list.length; i++) {
        if (parseInt(this.table_list[i].Status) !== 2) {
          this.showTableChangedWarning = true;
          return;
        }
      }
    },
    make_qr_data_url(text) {
      let bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("text", text);

      return axios({
        method: "post",
        url: "/Api/Web/Table/h5_qrcode",
        data: bodyFormData,
      }).then(function(response) {
        let rt = response.data || {};
        if (response.status == "200" && rt.status == 0 && rt.data && rt.data.data_url) {
          return rt.data;
        }
        throw new Error(rt.message || "Can not create QRCode image");
      });
    },
    refresh_qr_images() {
      let rows = this.allRows;
      let tasks = [];
      let that = this;
      for (let i = 0; i < rows.length; i++) {
        (function(row) {
          if (row.QRCodeImage) {
            that.$set(that.qrImages, row.key, row.QRCodeImage);
            that.$set(that.qrExtensions, row.key, row.QRCodeExtension || that.extension_from_data_url(row.QRCodeImage));
            return;
          }
          tasks.push(
            that.make_qr_data_url(row.QRCodeUrl).then(function(qrData) {
              that.$set(that.qrImages, row.key, qrData.data_url);
              that.$set(that.qrExtensions, row.key, qrData.extension || that.extension_from_data_url(qrData.data_url));
            })
          );
        })(rows[i]);
      }
      Promise.all(tasks).catch(function(error) {
        alert(error.message || "Can not create QRCode image");
      });
    },
    pdf_store_name() {
      return this.locationName || this.LocationID || "Store";
    },
    ensure_qr_data_url(row) {
      let dataUrl = this.qrImages[row.key];
      if (dataUrl) {
        return Promise.resolve(dataUrl);
      }
      let that = this;
      return this.make_qr_data_url(row.QRCodeUrl).then(function(qrData) {
        let imageDataUrl = qrData.data_url || qrData;
        that.$set(that.qrImages, row.key, imageDataUrl);
        that.$set(that.qrExtensions, row.key, qrData.extension || that.extension_from_data_url(imageDataUrl));
        return imageDataUrl;
      });
    },
    image_to_png_data_url(dataUrl) {
      if (dataUrl.indexOf("data:image/png") === 0 || dataUrl.indexOf("data:image/jpeg") === 0) {
        return Promise.resolve(dataUrl);
      }
      return new Promise(function(resolve, reject) {
        let image = new Image();
        image.onload = function() {
          let canvas = document.createElement("canvas");
          canvas.width = image.naturalWidth || 512;
          canvas.height = image.naturalHeight || 512;
          let ctx = canvas.getContext("2d");
          ctx.fillStyle = "#ffffff";
          ctx.fillRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
          resolve(canvas.toDataURL("image/png"));
        };
        image.onerror = function() {
          reject(new Error("Can not load QRCode image"));
        };
        image.src = dataUrl;
      });
    },
    trim_pdf_text(pdf, text, maxWidth) {
      let value = String(text || "");
      while (value.length > 0 && pdf.getTextWidth(value) > maxWidth) {
        value = value.substring(0, value.length - 1);
      }
      if (value !== String(text || "") && value.length > 1) {
        value = value.substring(0, value.length - 1) + "...";
      }
      return value;
    },
    fit_pdf_font_size(pdf, text, maxWidth, maxFontSize, minFontSize) {
      let value = String(text || "");
      pdf.setFontSize(maxFontSize);
      let textWidth = pdf.getTextWidth(value);
      if (!textWidth || textWidth <= maxWidth) {
        return maxFontSize;
      }
      return Math.max(minFontSize, maxFontSize * maxWidth / textWidth);
    },
    draw_pdf_item(pdf, row, index) {
      let pageIndex = index % PDF_ITEMS_PER_PAGE;
      let col = pageIndex % 4;
      let rowIndex = Math.floor(pageIndex / 4);
      let margin = 1;
      let gap = 0.6;
      let itemWidth = 4.3;
      let itemHeight = 4.9;
      let x = margin + col * (itemWidth + gap);
      let y = margin + rowIndex * (itemHeight + gap);
      let imageSize = 3.65;
      let imageX = x + (itemWidth - imageSize) / 2;
      let imageY = y + 0.95;

      pdf.setDrawColor(216, 222, 228);
      pdf.rect(x, y, itemWidth, itemHeight);

      pdf.setTextColor(17, 17, 17);
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(this.fit_pdf_font_size(pdf, this.pdf_store_name(), itemWidth - 0.35, 10, 3));
      pdf.text(this.pdf_store_name(), x + itemWidth / 2, y + 0.38, { align: "center" });

      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(9);
      pdf.text(this.trim_pdf_text(pdf, row.TName || "", itemWidth - 0.35), x + itemWidth / 2, y + 0.76, { align: "center" });

      pdf.addImage(row.QRCodeImage, "PNG", imageX, imageY, imageSize, imageSize);
    },
    download_pdf() {
      let rows = this.allRows;
      if (rows.length == 0) {
        alert("No QRCode to download");
        return;
      }
      this.show_loading = true;
      let that = this;
      Promise.all(rows.map(function(row) {
        return that.ensure_qr_data_url(row).then(function(dataUrl) {
          return that.image_to_png_data_url(dataUrl).then(function(pngDataUrl) {
            return Object.assign({}, row, { QRCodeImage: pngDataUrl });
          });
        });
      }))
        .then(function(pdfRows) {
          let pdf = new jsPDF({ unit: "cm", format: "a4", orientation: "portrait" });
          let filename = that.storeName + "scanQRCodes.pdf";
          for (let i = 0; i < pdfRows.length; i++) {
            if (i > 0 && i % PDF_ITEMS_PER_PAGE == 0) {
              pdf.addPage();
            }
            that.draw_pdf_item(pdf, pdfRows[i], i);
          }
          pdf.save(filename);
        })
        .catch(function(error) {
          alert(error.message || "Can not download QRCode PDF");
        })
        .finally(function() {
          that.show_loading = false;
        });
    },
    data_url_to_base64(dataUrl) {
      let parts = dataUrl.split(",");
      return parts.length > 1 ? parts[1] : "";
    },
    data_url_to_uint8(dataUrl) {
      let binary = atob(this.data_url_to_base64(dataUrl));
      let bytes = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i);
      }
      return bytes;
    },
    extension_from_data_url(dataUrl) {
      if (dataUrl.indexOf("data:image/svg+xml") === 0) {
        return "svg";
      }
      if (dataUrl.indexOf("data:image/png") === 0) {
        return "png";
      }
      return "img";
    },
    safe_filename(name) {
      let text = String(name || "QRCode").replace(/[\\/:*?"<>|]/g, "_").trim();
      return text || "QRCode";
    },
    unique_filename(name, used, extension) {
      let base = this.safe_filename(name);
      let ext = extension || "img";
      let filename = base + "." + ext;
      let counter = 2;
      while (used[filename]) {
        filename = base + "-" + counter + "." + ext;
        counter++;
      }
      used[filename] = true;
      return filename;
    },
    trigger_download(blob, filename) {
      let link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
    },
    download_zip() {
      let rows = this.allRows;
      if (rows.length == 0) {
        alert("No QRCode to download");
        return;
      }
      this.show_loading = true;
      let that = this;
      Promise.resolve()
        .then(function() {
          let files = {};
          let used = {};
          let tasks = [];
          for (let i = 0; i < rows.length; i++) {
            (function(row) {
              let dataUrl = that.qrImages[row.key];
              let task = Promise.resolve(dataUrl || that.make_qr_data_url(row.QRCodeUrl)).then(function(imageDataUrl) {
                if (imageDataUrl && imageDataUrl.data_url) {
                  dataUrl = imageDataUrl.data_url;
                  that.$set(that.qrImages, row.key, dataUrl);
                  that.$set(that.qrExtensions, row.key, imageDataUrl.extension || that.extension_from_data_url(dataUrl));
                } else {
                  dataUrl = imageDataUrl;
                }
                let extension = that.qrExtensions[row.key] || that.extension_from_data_url(dataUrl);
                files[that.unique_filename(row.TName, used, extension)] = that.data_url_to_uint8(dataUrl);
              });
              tasks.push(task);
            })(rows[i]);
          }
          return Promise.all(tasks).then(function() {
            return zipSync(files);
          });
        })
        .then(function(bytes) {
          let blob = new Blob([bytes], { type: "application/zip" });
          that.trigger_download(blob, "H5Tables-" + that.LocationID + ".zip");
        })
        .catch(function(error) {
          alert(error.message || "Can not download QRCode zip");
        })
        .finally(function() {
          that.show_loading = false;
        });
    },
    load_tables() {
      this.show_loading = true;
      let bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("LocationID", this.LocationID);
      bodyFormData.append("OnlineSourceIDn", this.OnlineSourceIDn);
      let that = this;

      axios({
        method: "post",
        url: "/Api/Web/Table/h5_table",
        data: bodyFormData,
      })
        .then(function(response) {
          if (response.status == "200") {
            let rt = response.data;
            if (rt.status == 0) {
              that.table_list = rt.data.table_list || [];
              that.pickup_url = rt.data.pickup_url || "";
              that.pickup_qrcode = rt.data.pickup_qrcode || null;
              that.SourceType = rt.data.online_source ? rt.data.online_source.SourceType : "";
              that.locationName = rt.data.LocationName || (rt.data.store ? (rt.data.store.LocationName || "") : "");
              that.storeName = that.locationName || rt.data.StoreName || (rt.data.store ? (rt.data.store.StoreName || "") : "");
              that.qrImages = {};
              that.qrExtensions = {};
              that.check_table_changed_warning();
              that.refresh_qr_images();
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function() {
          that.$router.push("/login");
        })
        .finally(function() {
          that.show_loading = false;
        });
    },
    send_h5_store_info() {
      if (!this.SourceType) {
        alert("Unknown online source");
        return;
      }
      this.sendingStoreInfo = true;
      let bodyFormData = new FormData();
      bodyFormData.append("token", this.token);
      bodyFormData.append("user_id", this.user_id);
      bodyFormData.append("LocationID", this.LocationID);
      bodyFormData.append("SourceType", this.SourceType);
      let that = this;

      axios({
        method: "post",
        url: "/Api/Web/Store/updateH5ApiStore",
        data: bodyFormData,
      })
        .then(function(response) {
          if (response.status == "200") {
            let rt = response.data;
            if (rt.status == 0) {
              that.text_message = that.$t("Data Updated Successfully");
              that.messageCountdown = 3;
              that.showTableChangedWarning = false;
            } else if (rt.status == 4) {
              alert(that.$t("No Permission"));
              that.$router.go(-1);
            } else if (rt.message != undefined) {
              alert(rt.message);
            }
          }
        })
        .catch(function() {
          that.$router.push("/login");
        })
        .finally(function() {
          that.sendingStoreInfo = false;
        });
    },
    init_data() {
      this.token = getStore("token");
      this.user_id = getStore("user_id");
      if (!this.token || !this.user_id) {
        this.$router.push("/login");
        return;
      }
      this.LocationID = this.$route.query.LocationID;
      this.OnlineSourceIDn = this.$route.query.OnlineSourceIDn || 0;
      if (!this.LocationID || !this.OnlineSourceIDn) {
        this.$router.push("/onlinestore");
        return;
      }
      this.load_tables();
    },
  },
  mounted() {
    let name = getStore("username");
    if (name && name != undefined && ((name == "PKAdmin") || (name == "posking"))) {
      this.init_data();
    } else {
      this.$router.push("/store");
    }
  },
};
</script>

<style scoped>
.content {
  padding-top: 80px;
}
.qr-image {
  border: 1px solid #e9ecef;
  border-radius: 4px;
  height: 120px;
  width: 120px;
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #3498db;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
